import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          平台优势
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 text-center cursor-default">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-primary-50 flex items-center justify-center">
                <i className={`${feat.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}